import Vue from 'vue';
import { JSEncrypt } from 'jsencrypt';

const rsaPublicKey = 'a'; // 安全问题，这里只是用来解密，不需要公钥，值用来占位

const rasPrivateKey = `-----BEGIN RSA PRIVATE KEY-----
MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBALPdwXdRyKrqiE+5U3SLkE7UBAwW
irB8gi65ztaRTnIpTxeKvXhx1Rba4vIKqOESIYDu9Jo5CTwcBQMsbY9QlKkmKH4rEfCaNwZxSGF1
8dokM2zkSIopa5KD4DFmkTPbVZr9477zTyjKGhx8TSc9pnT5xprd6boezptBmCXoUt3fAgMBAAEC
gYAZFr4VPDGu8Y74++NRtuP2sukrnHtU+dEY3m8lC9iy4OM45+/c3Jf6G6cbVvROjL5iozI4Tutk
WI40bp6LppRNtdQxlR4AXBSyUVXXmlG7XtTyB/6BKdUq4AJt/yE3LLV9yFFxuNBZ1LCVMd/i18Uv
tF9sYhQyvsDR0i+XYuNr+QJBAOYME8JLEpAvEFNDTEwAMlANYG2DVToiA3JKMfSKtyF4S/YZnmrp
VN3YFtAAONCYVTOou5cimykUkAYy01vo0bkCQQDIKGr9GTbWizvVLTNKsw+cPlUGP6aJw1RBSFBq
8scbcLkLpdUjbT6wBfwG3RrLUPwYTih+R5946Q+O+gXC/FhXAkBKdGA0ww1oAwN6n05jTrD5/cpW
x2nfHcEVzXOrnPW2bHPRW+tM2OXxww1nFptMz/DLfnHwcW/cdN5EU1Da71hpAkEAwxpyv2c2hwaN
OgynNKc6DijMJB0jLqIRnNjqWnVwE5VbKrlo+vFf66DJu78GgSzdrqtw2Tbjga5cFhgsSZZEXQJA
DhVlX9IY251f/THNccfjFobxNU/xc7xJMOaomDPmdT7l+Q/ZlZdN0dL5Kfo50QEaATE1HZ6u4B1F
hfq6lJDAaw==
-----END RSA PRIVATE KEY-----`;

export default {
  encrypt(value) {
    const jsencrypt = new JSEncrypt();
    jsencrypt.setPublicKey(rsaPublicKey);
    return jsencrypt.encrypt(value);
  },
  decrypt(value) {
    const jsdecrypt = new JSEncrypt();
    jsdecrypt.setPrivateKey(rasPrivateKey);
    return jsdecrypt.decrypt(value);
  },
};
